import { render, staticRenderFns } from "./inputRender.vue?vue&type=template&id=267612d0&scoped=true"
import script from "./inputRender.vue?vue&type=script&lang=js"
export * from "./inputRender.vue?vue&type=script&lang=js"
import style0 from "./inputRender.vue?vue&type=style&index=0&id=267612d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267612d0",
  null
  
)

export default component.exports